'use client';
import Link from 'next/link';
import { captureException } from '@sentry/nextjs';
import { CSSProperties, useEffect } from 'react';
import Image from 'next/image';
import { DAVINCI_CDN } from '@/costants/defaultValues';

const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f9fafb',
    color: '#0F3250',
    padding: '20px',
  },
  image: {
    marginBottom: '10px',
  },
  title: {
    fontSize: '48px',
    margin: '0 0 16px 0',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#0F3250',
  },
  text: {
    fontSize: '18px',
    marginBottom: '32px',
    color: '#0F3250',
    maxWidth: '500px',
    textAlign: 'center',
    lineHeight: '1.5',
  },
  button: {
    display: 'inline-block',
    backgroundColor: '#2563eb',
    color: '#ffffff',
    padding: '12px 24px',
    borderRadius: '8px',
    textDecoration: 'none',
    fontSize: '16px',
    fontWeight: '600',
    border: 'none',
    cursor: 'pointer',
  },
} satisfies { [key: string]: CSSProperties };

const GlobalError = ({ error }: { error: Error & { digest?: string } }) => {
  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <div style={styles.container}>
      <Image src={`${DAVINCI_CDN}/inclinic/icons/eye_look.png`} style={styles.image} alt={''} width={150} height={150} />

      <h1 style={styles.title}>Qualcosa è andato storto</h1>

      <p style={styles.text}>errore 500</p>

      <Link href="/" style={styles.button}>
        Torna alla pagina iniziale
      </Link>
    </div>
  );
};

export default GlobalError;
